import { AxiosHttpServiceBuilder } from '@wallbox/http'
import { wapiSessionRepositoryBuilder } from './WapiSessionRepository'

export const wapiSessionRepository = () => wapiSessionRepositoryBuilder({
  httpService: new AxiosHttpServiceBuilder()
})
